import React from 'react';
import {
	Container,
	ContainerGutter,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';

export const expressServiceLayer: ServiceLayer = {
	header: 'Servicios del taller',
	title: 'Express Service',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			Sabemos que dejar el coche en el taller puede alterar todos tus planes. Así que no lo hagas. Con este servicio,
			dos técnicos trabajarán a la vez en tu Volkswagen para tenerlo listo en 60 minutos desde tu llegada. Disponible
			solo para algunas operaciones, como revisiones y cambios por desgaste de frenos o neumáticos.
		</Text>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				Así funciona el servicio, paso a paso:
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				<List gutter={ListGutter.dynamic0020}>
					<ListItem>
						Recepción: cuando llegues a tu taller, nuestros profesionales ya tendrán listo todo lo necesario para llevar
						a cabo la revisión de tu coche. Sé puntual y trae las dos llaves de tu Volkswagen contigo para ser lo más
						eficientes posibles.
					</ListItem>
					<ListItem>
						Espera rápida: habilitaremos una área de descanso para que puedas relajarte mientras se encargan de tu
						Volkswagen. Aunque no será por demasiado tiempo.
					</ListItem>
					<ListItem>
						Entrega: en menos de una hora, uno de nuestros profesionales te avisará de que tu coche ya está listo y
						podrás llevártelo contigo. ¡Así de fácil!
					</ListItem>
				</List>
			</Text>
		</Container>
	),
	imageContent:
		'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-servicios/layers/express-service.jpg',
};
